// extracted by mini-css-extract-plugin
export default {"container":"CookieConsent_container__24hif","text":"CookieConsent_text__3M0EC","button":"CookieConsent_button__1GM-h"};